import React from 'react';
import graphic_report from '../../../assets/img/graphic-report-collapsed-sm.svg';

export const QuadrantListCollapsed = ({ user }) => {

    return (
        <>
            <div className="px-0 justify-content-center align-items-stretch d-flex">
                <div className="px-0 d-flex flex-column text-right" style={{width: '88px'}}>
                    <div className="cursor-pointer mt-auto border-bottom pr-2">
                        <h6 className="mb-0 font-weight-medium small py-2" >Analytic 
                            <span className='pl-1 font-weight-bold h6'>
                            {
                                user.talents &&
                                user.talents.map(quadrant =>
                                    quadrant.quadrant === 'Analytic' &&
                                    quadrant?.counts?.always
                                )
                            }
                            </span>
                        </h6>
                    </div>
                    <div className="cursor-pointer mb-auto pr-2">
                        <h6 className="mb-0 font-weight-medium small py-2">
                            Procedural 
                            <span className='pl-1 font-weight-bold h6'>
                            {
                                user.talents &&
                                user.talents.map(quadrant =>
                                    quadrant.quadrant === 'Procedural' &&
                                    quadrant?.counts?.always
                                )
                            }
                            </span>
                        </h6>
                    </div>
                </div>

                <div className="bg-map-dk">
                    <div className="mx-auto" style={{ width: '88px' }}>
                        <div className="mx-auto text-center graphic-list-all-talent-collapsed d-flex flex-column align-items-center justify-content-center">
                                <h6 className="text-center mb-0 font-weight-medium small" >All</h6>
                                <span className='font-weight-bold h6'>
                                {
                                    user.talents &&
                                    user.talents.map(quadrant =>
                                        quadrant.quadrant === 'All' && 
                                        quadrant?.counts?.always
                                    )
                                }
                                </span>
                        </div>
                        <img src={graphic_report} id={user.id} className="img-fluid" alt='graphic' />
                    </div>
                </div>

                <div className="px-0 d-flex flex-column" style={{width: '84px'}}>
                    <div className="cursor-pointer mt-auto border-bottom pl-2">
                        <h6 className="mb-0 font-weight-medium small py-2" >
                            Innovative 
                            <span className='pl-1 font-weight-bold h6'>
                            {
                                user.talents &&
                                user.talents.map(quadrant =>
                                    quadrant.quadrant === 'Innovative' &&
                                    quadrant?.counts?.always
                                )
                            }
                            </span>
                        </h6>
                    </div>

                    <div className="cursor-pointer mb-auto pl-2">
                        <h6 className="mb-0 font-weight-medium small py-2" >
                            Relational 
                            <span className='pl-1 font-weight-bold h6'>
                            {
                                user.talents &&
                                user.talents.map(quadrant =>
                                    quadrant.quadrant === 'Relational' &&
                                    quadrant?.counts?.always
                                )
                            }
                            </span>
                        </h6>
                    </div>
                </div>
            </div>
        </>
    )
}
